module.exports = __webpack_public_path__ + "img/green_043.0c37a06c.png";